let initState = {
  //个人信息
  userInfo: {
    captcha: '',
    certName: '',
    certNo: '',
    checkCode: '',
    contactNum: '',
    postAddr: ''
  },
  //前置信息
  placeOfOwnership: {
    mediaLink: window.location.href,
    provinceCode: '', //	号码归属地省份编码
    province: '', //	号码归属地省份
    cityCode: '', //		号码归属地城市编码
    city: '', //		号码归属地城市
    cardType: '', //卡种类型
    channel: '' //渠道
  },
  shdCache: {
    //收货地
    postProvince: '', // 邮寄省名称
    postProvinceCode: '', // 邮寄省id
    postCity: '', //邮寄市名称
    postCityCode: '', // 邮寄市id
    postDistrict: '', //邮寄区县
    postDistrictCode: '' //邮寄区县id
  },
  cityCache: {
    province: '',
    city: '',
    county: ''
  },
  provinceCityText: '',
  HunanTelecomMurmur: '',
  broadbandIntention: 0
}
let cloneDeep = data => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {
  // SET_ORDERFORM: (state, orderForm) => {
  //     state.orderForm = orderForm
  // },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = null
    state.userInfo = userInfo
  },
  SET_PLACEOFOWNERSHIP: (state, placeOfOwnership) => {
    state.placeOfOwnership = placeOfOwnership
  },
  SET_GSDCACHE: (state, shdCache) => {
    state.shdCache = shdCache
  },
  SET_PROVINECECITYTEXT: (state, provinceCityText) => {
    state.provinceCityText = provinceCityText
  },
  SET_CITYCACHE: (state, cityCache) => {
    state.cityCache = cityCache
  },
  INIT_STATE: state => {
    Object.assign(state, cloneDeep(initState))
  },
  SET_HUNANTELECOMMURMUR: (state, HunanTelecomMurmur) => {
    state.HunanTelecomMurmur = HunanTelecomMurmur
  },
  SET_BROADBANDINTENTION: (state, broadbandIntention) => {
    state.broadbandIntention = broadbandIntention
  }
}

const actions = {
  /**
   *  靓号下单缓存到vuex里面
   *
   *
   */
  async setOrderForm({ commit, dispatch }, data) {
    commit(`SET_ORDERFORM`, data)
  },
  setPlaceOfOwnership({ commit, dispatch }, data) {
    commit(`SET_PLACEOFOWNERSHIP`, data)
  },
  setUserInfo({ commit, dispatch }, data) {
    commit(`SET_USERINFO`, data)
  },
  setShdCache({ commit, dispatch }, data) {
    //这里应该是收货地
    commit(`SET_GSDCACHE`, data)
    const { postProvinceCode: province, postCityCode: city, postDistrictCode: county, postProvince, postCity, postDistrict } = data
    dispatch(`setCityCache`, { province, city, county })
    dispatch(`setProvinceCityText`, `${postProvince} - ${postCity} - ${postDistrict}`)
  },

  initShdCache({ commit, dispatch }) {
    commit(`SET_GSDCACHE`, {
      postProvince: '', // 邮寄省名称
      postProvinceCode: '', // 邮寄省id
      postCity: '', //邮寄市名称
      postCityCode: '', // 邮寄市id
      postDistrict: '', //邮寄区县
      postDistrictCode: '' //邮寄区县id}
    })
    dispatch(`setCityCache`, { province: '', city: '', county: '' })
    dispatch(`setProvinceCityText`, '')
  },
  initGsdCache: ({ commit }) => {
    commit(`SET_GSDCACHE`, {
      postProvince: '', // 邮寄省名称
      postProvinceCode: '', // 邮寄省id
      postCity: '', //邮寄市名称
      postCityCode: '', // 邮寄市id
      postDistrict: '', //邮寄区县
      postDistrictCode: '' //邮寄区县id}
    })
    commit(`SET_CITYCACHE`, {
      province: '',
      city: '',
      county: ''
    })
    commit(`SET_PROVINECECITYTEXT`, '')
  },
  setCityCache({ commit }, data) {
    commit(`SET_CITYCACHE`, data)
  },
  setProvinceCityText({ commit }, string) {
    commit(`SET_PROVINECECITYTEXT`, string)
  },
  initState({ commit }) {
    commit(`INIT_STATE`)
  },
  setHunanTelecomMurmur({ commit }, string) {
    commit(`SET_HUNANTELECOMMURMUR`, string)
  },

  setBroadbandIntention({ commit }, bool) {
    commit(`SET_BROADBANDINTENTION`, bool ? 1 : 0)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
